import { createBrowserRouter } from "react-router-dom";
import PrivateRoute from "./HOC/PrivateRoute";
import RestrictedRoute from "./HOC/RestrictedRoute";
import PreLogin from "../components/PreLogin/PreLogin";

const wrapPrivateRoutes = (routesArray) => {
  return routesArray.map((route) => {
    let newRoute = { ...route };

    if (route.isPrivate) {
      newRoute = {
        ...newRoute,
        element: <PrivateRoute component={route.element} />,
        children: [
          {
            index: !route.path,
            path: "",
            element: route.element,
          },
          ...(route.children ? wrapPrivateRoutes(route.children) : []),
        ],
      };
    } else if (route.isRestricted) {
      if (route.children) {
        newRoute = {
          ...newRoute,
          element: <RestrictedRoute component={PreLogin} />,
          children: [
            {
              index: !route.path,
              path: "",
              element: route.element,
            },
            ...(route.children ? wrapPrivateRoutes(route.children) : []),
          ],
        };
      } else {
        newRoute = {
          element: <RestrictedRoute />,
          children: [
            {
              path: route.path,
              element: route.element,
            },
          ],
        };
      }
    } else if (route.children) {
      newRoute.children = wrapPrivateRoutes(route.children);
    }

    return newRoute;
  });
};

let routes = require(process.env.REACT_APP_ROUTES_PATH).default;
const router = createBrowserRouter(wrapPrivateRoutes(routes ?? []));

export default router;
